module.exports = __webpack_public_path__ + "assets/twitter.e3df990a.svg";